import { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Icon } from '@mdi/react';
import { useCopy } from './utils';

type Props = {
  text: string;
};

/**
 * @summary - Кнопка для копирования.
 * @param text - Текст, который нужно скопировать.
 */
export const CopyButton: FC<Props & ButtonProps> = ({ text, color, ...rest }) => {
  const { copy, copyState, title, colorIcon, path } = useCopy(text);
  return (
    <Button
      variant="contained"
      onClick={copy}
      onDoubleClick={copy}
      startIcon={copyState === 0 ? undefined : <Icon path={path} size={1} />}
      {...rest}
      color={colorIcon}
    >
      {title}
    </Button>
  );
};
